<template>
  <div>
    <div class="d-flex mt-2">
      <feather-icon icon="TruckIcon" size="19" />
      <h4 class="mb-0 ml-50">
        {{ $t("DEVICES_FORM_MASADER_TAB_TITLE") }}
      </h4>
    </div>

    <b-row class="mt-2">
      <b-col md="6">
        <b-form-group :label="$t('DEVICES_FORM_ASSIGN_TO_MASADER_LABEL')">
          <b-form-checkbox
            v-model="assign_to_masader"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small
            v-if="'assign_to_masader' in $store.getters['device/errors']"
            class="text-danger"
          >
            {{ $t($store.getters["device/errors"]["assign_to_masader"][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12"><hr /></b-col>
      <b-col cols="12">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-1"
        >
          {{ $t("Save") }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCol, BFormGroup, BRow, BFormCheckbox, BButton } from "bootstrap-vue";

import { computed } from '@vue/composition-api'

import { OrbitSpinner } from "epic-spinners";

import Ripple from "vue-ripple-directive";

import store from "@/store";

export default {
  props: {},
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    OrbitSpinner,
    BFormCheckbox,
    BButton
  },
  setup(props, { root }) {
    return { 
      assign_to_masader: computed({
        set(value){ 
          store.commit('device/SET_ASSIGN_TO_MASADER', { value }) 
        }, 
        get(){
          return store.getters['device/assign_to_masader']
        }
      }),
      computed
     };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.custom-timeline,
.d-flex.flex-sm-row.flex-column.flex-wrap.justify-content-between.mb-1.mb-sm-0
  h6 {
  font-size: 19px;
  font-style: oblique;
  font-weight: bold;
}
</style>
